<template>
  <section>
    <b-modal
      :active.sync="OpenModalAddQuestions"
      has-modal-card
      :can-cancel="false"
    >
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Agregar Preguntas</p>
        </header>
        <form action v-on:submit.prevent="createQuestion">
          <section class="modal-card-body">
            <h1>Nombre de la Enucesta: {{ name }}</h1>
            <h1>Descripción: {{ description }}</h1>
            <b-field label="Pregunta">
              <b-input
                type="text"
                :value="Question.question"
                v-model="Question.question"
                placeholder="Nombre"
                required
              ></b-input>
            </b-field>
            <b-field label="Tipo de Pregunta">
              <b-select
                placeholder="Seleccionar el Tipo de Pregunta"
                v-model="Question.type_selection_id"
                expanded
                required
              >
                <option
                  v-for="type in listTypeSelection"
                  :value="type.id"
                  :key="type.id"
                >
                  {{ type.name }}
                </option>
              </b-select>
            </b-field>
            <button @click="addQuestion()" class="button is-small is-info">
              Agregar Alternativa
            </button>
            <div v-for="Question in Questions" :key="Question.index">
              <b-field :label="'Alternativa ' + Question.index">
                <b-input
                  type="text"
                  :value="Question.value"
                  v-model="Question.value"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeBasic()">
              Cerrar
            </button>
            <button class="button is-primary" type="submit">Guardar</button>
          </footer>
        </form>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { getQuestionarie } from "../../../services/questionarie";
import { storeQuestion } from "../../../services/question";
import { getTypeSelection } from "../../../services/type_selection";
import { storeAlternative } from "../../../services/alternatives";
import { storeQuestionAlternative } from "../../../services/question_alternative";

export default {
  props: ["OpenModalAddQuestions", "closeBasic", "questionarie_id"],
  data() {
    return {
      name: "",
      description: "",
      Question: {
        question: "",
        questionary_id: this.questionarie_id,
        type_selection_id: "",
      },
      Questions: [],
      listTypeSelection: [],
      isLoading: false,
    };
  },
  created: function () {
    this.chargeData().then((this.isLoading = false));
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      await getQuestionarie(this.$http, this.questionarie_id).then(
        (response) => {
          this.name = response.name;
          this.description = response.description;
        }
      );
      await getTypeSelection(this.$http).then((response) => {
        this.listTypeSelection = response;
      });
    },
    async createQuestion() {
      this.isLoading = true;
      console.log(this.Question);
      await storeQuestion(this.$http, this.Question).then(async (response) => {
        var question_id = response.id;
        let data2 = {
          alternative: 'En Blanco',
        };
        await storeAlternative(this.$http, data2).then(async (response) => {
          let data = {
            question_id: question_id,
            alternative_id: response.id,
          };
          await storeQuestionAlternative(this.$http, data).then((response) => {
            console.log(response);
          });
        });
        this.Questions.forEach(async (element) => {
          let data = {
            alternative: element.value,
          };
          await storeAlternative(this.$http, data).then(async (response) => {
            let data = {
              question_id: question_id,
              alternative_id: response.id,
            };
            await storeQuestionAlternative(this.$http, data).then(
              (response) => {
                console.log(response);
              }
            );
          });
        });
        this.closeBasic();
        this.toast("Creado", "is-success");
      });
    },
    addQuestion() {
      this.Questions.push({
        index: this.Questions.length + 1,
        value: "",
      });
    },
  },
};
</script>